function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import ProofsSectionComponent from "./components/proofs-section-component";
import BadgesSectionComponent from "./components/badges-section-component";
import { StyledProofAndBadgesEnterpriseComponent } from "./proof-and-badges-enterprise-component.scss";
const ProofAndBadgesEnterpriseComponent = (props)=>{
    const { proofsSection, badgesSection, sideBySideAdvancedProps } = props;
    return /*#__PURE__*/ _jsx(StyledProofAndBadgesEnterpriseComponent, {
        className: "proof-and-badges-enterprise-component",
        children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
            replaceTextComponent: ProofsSectionComponent,
            replaceAssetComponent: BadgesSectionComponent,
            replaceTextComponentProps: proofsSection,
            replaceAssetComponentProps: badgesSection
        }, sideBySideAdvancedProps))
    });
};
export default ProofAndBadgesEnterpriseComponent;
